import React, { useState } from 'react';
import { SignInScreenView } from '../SignInScreen';
import TextInput from '../../../components/TextInput/TextInput';
import { TranslationKey } from '../../../../types/translation/TranslationKey';
import { t } from '../../../../types/translation/Translator';
import { Button, ButtonVariant } from '../../../components/Button';
import { useRequest } from '../../../../requests/common/requestHook';
import { AuthenticationRequest } from '../../../../requests/auth.request';
import { handleKeyEvent } from '../../../../util/events.util';
import { useToast } from '../../../../providers/ToastProvider';
import { ToastType } from '../../../components/Toast';

interface ForgotPasswordViewProps {
  setView: (view: SignInScreenView) => void;
}

export default function ForgotPasswordView({ setView }: ForgotPasswordViewProps) {
  const { showToast } = useToast();
  const [email, setEmail] = useState<string>('');

  const [reset, { loading }] = useRequest(AuthenticationRequest.resetPassword);

  const handleReset = async () => {
    if (!email) return;
    await reset({ email });
    showToast({ type: ToastType.success, title: `A reset email has been sent to ${email}` });
  };

  return (
    <>
      <p className='my-2 text-center text-2xl font-bold'>{'Reset Password'}</p>
      <div onKeyDown={async event => handleKeyEvent(event, 'Enter', handleReset)}>
        <TextInput
          mandatory
          disabled={loading}
          value={email}
          label={t(TranslationKey.email).singular.label}
          placeholder={t(TranslationKey.email).singular.label}
          onChange={v => setEmail(v)}
        />
      </div>
      <Button disabled={!email} loading={loading} text={t(TranslationKey.reset).singular.label} onClick={handleReset} />
      <Button
        disabled={loading}
        variant={ButtonVariant.secondary}
        text={t(TranslationKey.back).singular.label}
        onClick={() => setView(SignInScreenView.credentials)}
      />
    </>
  );
}
